import { useGetOrgSecurity, useSetOrgSecurity } from '@myrentalmate/api-client';
import {
  Alert,
  FormControlLabel,
  Link as MuiLink,
  Paper,
  Stack,
  Switch,
  Typography,
} from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { Link } from 'react-router';

import { okData } from '../../lib/apiData';
import { apiErrorMessage } from '../../lib/apiError';
import { useMe } from '../../lib/me';

export function SecuritySettingsPage() {
  const { data: me } = useMe();
  const queryClient = useQueryClient();
  const security = okData(useGetOrgSecurity().data);
  const save = useSetOrgSecurity({
    mutation: { onSuccess: () => queryClient.invalidateQueries() },
  });
  return (
    <Paper variant="outlined" sx={{ p: 3, maxWidth: 640 }}>
      <Typography variant="h6">Two-Factor Sign-In</Typography>
      <Typography color="text.secondary" sx={{ mb: 2 }}>
        Staff sign in with their password and a code from an authenticator app. This is optional.
        When it's on, staff without two-factor must set it up the next time they use the app.
        Residents and owners aren't affected.
      </Typography>
      <Stack spacing={2} sx={{ alignItems: 'flex-start' }}>
        <FormControlLabel
          label="Require Two-Factor for All Staff"
          control={
            <Switch
              checked={security?.mfa_required ?? false}
              disabled={!security || save.isPending}
              onChange={(e) => save.mutate({ data: { mfa_required: e.target.checked } })}
            />
          }
        />
        {me && !me.mfa_enabled && (
          <Alert severity="info">
            To turn this on, first set up two-factor for yourself in{' '}
            <MuiLink component={Link} to="/account">
              My profile
            </MuiLink>
            .
          </Alert>
        )}
        {save.isError ? <Alert severity="error">{apiErrorMessage(save.error)}</Alert> : null}
      </Stack>
    </Paper>
  );
}
